import { Link } from 'react-router-dom';
import { assetUrl } from '../../utils/assetUrl';

/**
 * Marketing-site footer.
 *
 * Ported verbatim from the HTML draft's `<footer class="site-footer">`
 * block. All internal navigation uses React Router's `<Link>`. The bottom
 * "homeplated.com" text is intentionally plain text (matches the source);
 * if it should be a link, add a Link wrapper later.
 */
export const SiteFooter: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <img
              src={assetUrl('/logo-cream.svg')}
              alt="HomePlated"
              style={{ height: 36 }}
            />
            <p className="footer-tagline">
              Neighbor made, community crafted.
              <br />
              Real food. From real kitchens. Right near you.
            </p>
          </div>
          <div>
            <h5>Explore</h5>
            <ul>
              <li><Link to="/eaters">For Eaters</Link></li>
              <li><Link to="/chefs">For Chefs</Link></li>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/safety">Safety &amp; Compliance</Link></li>
            </ul>
          </div>
          <div>
            <h5>Community</h5>
            <ul>
              <li><Link to="/ambassador">Ambassador Program</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/code-of-conduct">Code of Conduct</Link></li>
            </ul>
          </div>
          <div>
            <h5>Legal</h5>
            <ul>
              <li><Link to="/privacy">Privacy</Link></li>
              <li><Link to="/terms">Terms</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <div>© 2026 HomePlated<sup className="tm">™</sup>. Built on trust, not transactions.</div>
          <div>homeplated.com</div>
        </div>
      </div>
    </footer>
  );
};
